export const socketActionData = [
  {
    name: 'sendSocketMessage',
    label: 'Send Socket Notification',
    args: [
      {
        name: 'socketIoTemplate',
        label: 'Socket IO Template',
        type: 'dropdown',
        optionsType: 'socketIoTemplateApi',
        options: [],
        value: '',
      },
    ],
  },
];
